module.exports = __webpack_public_path__ + "static/banner-primer-curso-3c237e291b09fe5b85561c0313ea02bd.jpg";